import axios from "axios";
import React, {Component} from "react";
import { Link } from "react-router-dom";
import Loading from "../components/Loading";
import Head from "../partials/Head";
import InvoiceDesign from "../components/InvoiceDesign";
import { toast } from "react-toastify";

class Invoice extends Component{

    state = {
        isModal : false,
        formDataInvoice : null,
        clientId : null,
        invoices : [],
        invoicesCount : [],
        currentPage : 1,
        clients : [],
        invoicesInvoice : [],
        due : 0,
        ref_invoice : 0,
        priceInvoice : 0,
        type : "Cash",
        typeInvoice : "Cash",
        error : "",
        colTable : '',
        loading : false,
        isRecherche : false,
        isClient : false
    }

    componentDidMount(){
        this.getInvoices();
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    async getInvoices(status = null, page = 1){
        this.setState({
            loading : true
        })
        let branche = localStorage.getItem('branche')
        branche = branche ?  JSON.parse(branche):{}
        
        if(status?.column)
        {
            let request = await axios.get('/invoices/$' + status?.column + '$/' + status?.value +"/" + page);
            if(request.status === 200)
                this.setState({invoices : request.data, loading : false})
        }
        else{
            status = status ? status : "Cash"
            let request = this.handleCheck("admin") ? await axios.get('/invoices/type/' + status +"/"+ page) : await axios.get('/invoices/brancheId/' + branche.userprofile?.brancheId  +'/type/' + status +"/"+ page);
            if(request.status === 200)
                this.setState({invoices : request.data, isModal : false, loading : false})

            request = this.handleCheck("admin") ? await axios.get('/invoices/count/status') : await axios.get('/invoices/count/status/brancheId/' + branche?.userprofile?.brancheId);
            if(request.status === 200)
                this.setState({invoicesCount : request.data})
        }
    }

    showModalInvoic = (val = 1) =>{
        let data = {
            id : null,
            invoiceId : null,
            ref_number : null,
            manifestecoliId : null,
            due : 0,
            column : "$invoices.id$",
            type : "FACTURE"
        }
        this.setState({
            formDataInvoice : data,
            isInvoiceModal : !this.state.isInvoiceModal
        })
        if(val == 1)
            this.getInvoices()
    }

    showModalInvoic_ = (val, type, column) =>{
        let data = null
        if(val && val != 1)
        {
            data = {
                id : val?.coli?.id,
                manifestecoliId : val?.manifestecoli?.id ,
                invoiceId :  null,
                ref_number : null,
                due : val?.due,
                column : column,
                type : type
            }
            this.setState({ formDataInvoice : data, isInvoiceModal : !this.state.isInvoiceModal})
        }
        if(val == 1)
            this.getInvoices(this.state.typeInvoice)
    }
    
    showModalInvoice = (invoice, manifestecoliId = false) =>{
        
        let data = {}
        if(invoice && invoice != 1)
        {
            data = {
                id : invoice.id,
                invoiceId : invoice?.id,
                ref_number : invoice?.ref_invoice,
                manifestecoliId : manifestecoliId,
                due : invoice?.due,
                column : "$invoices.id$",
                type : "FACTURE"
            }
        }
        this.setState({ formDataInvoice : data, isInvoiceModal : !this.state.isInvoiceModal})
        if(invoice == 1)
            this.getInvoices(this.state.typeInvoice)
    }


    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    storeInvoice = () => {
        if(this.state.clientId){
            var data = {
                price : this.state.priceInvoice,
                due : this.state.due,
                ref_invoice : this.state.ref_invoice,
                type : this.state.type,
                client_id : this.state.clientId,
                invoices : this.state.invoicesInvoice
            }
    
            var request = this.state.id ? axios.put('invoices/'+this.state.id, data) : axios.post('invoices', data);
            request.then((response) =>{
                this.setState({
                    btn : !this.state.btn
                })
                this.showFacture()
            }).catch((error) => {
                this.setState({
                    error : error.response.data.msg,
                    btn : !this.state.btn
                })
            })
        }else
            this.setState({ error : "Client can not be null"});
    }

    delete = (coli) =>{
        axios.delete("invoices/" + coli).then((response) => {
            toast(response.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
            this.getInvoices()
        }).catch((error)=>{})
    }

    changeType = (type)  => {
        this.getInvoices(type)
        this.setState({
            currentPage : 1,
            typeInvoice : type,
            isRecherche : false,
            column : ""
        })
    }

    changePage = (page) =>{
        this.setState({ currentPage : parseInt(page)})
        this.getInvoices(this.state.typeInvoice, parseInt(page))
    }

    handleCheck(val) {
        let permissions = JSON.parse(localStorage.getItem("permissions")) ? JSON.parse(localStorage.getItem("permissions")) : [];
        return permissions.some(item => val === item.name)
    }

    render(){

        const  PAGINATE = parseInt(process.env.REACT_APP_PAGINATE)
        let activate = "", countinvoices = 0;
        let status = 
        ['Cash', 'Dette'].map((type, count) => {
            let detes = this.state.invoicesCount.filter(val => val.type == "Dette")
            activate = ""
            if(this.state.typeInvoice == type) activate = " is-tab-el-active ";
            countinvoices = this.state.invoicesCount.filter(val => val.type == type)
            countinvoices = countinvoices.length == 1 ? countinvoices[0].count : 0
            if(type =="Cash")
                countinvoices += (detes[0]?.count || 0)
            return(
                <div className="col-auto" key={type}>
                    <button onClick={ () => this.changeType(type)} className={"tabs__button text-16 lg:text-16 text-light-1 fw-500 pb-5 lg:pb-0 js-tabs-button " + activate }  data-tab-target={".-tab-item-" + (count++)}> { type } ({ countinvoices })</button>
                </div>
            )
        })

        status.push(<div className="col-auto"><Link to="#" className="btn btn-sm m-0 rounded-100 py-2 px-10 text-center text-14 fw-500 bg-blue-1-05 text-blue-1" type="button" onClick={() => this.showModalInvoice()}>Rechercher coli</Link></div>)

        let buttons = [], elements = [], count = 0;
        this.state.invoicesCount.filter(val => val.type == this.state.typeInvoice).map((val, valcount) => {
            let indece = 0
            if(val.type =="Cash"){
                let detes = this.state.invoicesCount.filter(val => val.type == "Dette")
                indece += (detes[0]?.count || 0)
            }
            for (let index = 0; index <= (val.count + indece); index += PAGINATE) {
                count += 1
                elements.push(count)
            }
        })

        buttons = 
        elements.map((element) => {
            return(
                <div className="col-auto">
                    <div type="button" onClick={ () => this.changePage( element  ) } className={ element  == this.state.currentPage ? "size-30 flex-center rounded-full bg-dark-2 text-white" : "size-30 flex-center rounded-full bg-light-2"}>{ element }</div>
                </div>
            )
        })

        let invoices =
        this.state.invoices.map((invoice, count) => {
            let sum = 0
            invoice.manifestecoli?.manifestecolidetails?.map(manifestecolidetail => { sum += manifestecolidetail.quantity }) 
            return(
                <tr key={invoice.id}>
                    <td>{ (count + (this.state.currentPage * PAGINATE)+1)-PAGINATE}</td>
                    <td><Link to={"#"} onClick={ () => this.showModalInvoice(invoice)}>{ invoice.ref_invoice } <span className={ invoice.coli?.destination?.id == process.env.REACT_APP_ID_BK ?  "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-yellow-4 text-yellow-3" : "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-green-1 text-green"}>{ invoice?.coli?.destination?.city }</span></Link> </td>
                    <td><Link to={  this.handleCheck("afficher manifeste") == true ? "/manifestes/" + invoice.manifestecoli?.manifeste?.id : "#"}>{ invoice.manifestecoli?.manifeste?.ref_manifeste } </Link><small type="button" onClick={ () => { /*this.showModalInvoic(coliD.id, invoice, invoice.id)*/ } } className={ invoice.manifestecoli?.manifeste?.status == "EnCours" ? "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-blue-1-05 text-blue-1" : invoice.manifestecoli?.manifeste?.status == "Cloture" ? "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-yellow-4 text-yellow-3" : "rounded-100 py-4 px-10 text-center text-10 fw-500 bg-green-1 text-green"}> { invoice.manifestecoli?.manifeste?.status }</small></td>
                    <td><Link to={"/profile/" + invoice.client?.id}>{ invoice?.client?.name }</Link></td>
                    <td>{ sum > 0 ? sum : invoice.coli?.quantity }</td>
                    <td>{ invoice.price }</td>
                    { this.state.typeInvoice == "Dette" && (<td><span className="text-danger" onClick={() => this.showModalInvoic_(invoice, "FACTURE", "$colis.id$")}>{ invoice.due  }</span></td>)}
                    { this.state.typeInvoice == "Cash" && (<th>{ invoice.litige > 0 ? invoice.litige : ""}</th>)}
                    {/* <td>{ invoice.colis.map(coli => { return coli.colidetails.map(detail => { return <span>{ detail.quantity}{ detail.unite?.name} { detail.article?.name}, </span>}) }) }  </td> */}
                    <td><small>{ new Date(invoice.createdAt).toLocaleDateString("en-GB") }</small></td>
                </tr>
            )
        })
        return(
         
                    
                    <div className="dashboard__content bg-light-2">
                           
                            <div className="breadcrumbs">
                                <Head title={'Liste des factures'} url={'/invoices/'} logo={'/logo192.png'} />
                                <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
                                    <div className="col-auto">

                                        <h1 className="text-25 lh-14 fw-500 text-primary">{ 'Facture ' + this.state.typeInvoice}</h1>
                                        <div className="text-15 text-light-1">{ 'Liste des factures avec paiement ' +this.state.typeInvoice }</div>

                                    </div>

                                </div>
                            </div>

                                
                        {/* <div className="border bg-white p-1 m-1"><Profil /></div> */}

                        <div className="py-30 px-30 rounded-4 bg-white shadow-3">
                            <div className="tabs -underline-2 js-tabs row">
                                <div className="row y-gap-20 justify-between items-end">
                                    <div className="col-auto">
                                        <div className="tabs__controls row x-gap-40 y-gap-10 lg:x-gap-20 js-tabs-controls">
                                            { status }
                                        </div>
                                    </div>

                                    <div className="col-auto">
                                        <form className="row form">
                                            <div className="col-auto m-0 p-0 ms-1"><Link to="#" onClick={ () => this.setState({ isRecherche : !this.state.isRecherche, column : "" })}  className="rounded-100 py-2 px-10 text-center text-14 fw-500 bg-blue-1-05 text-blue-1">Rechercher</Link> </div>
                                            <div className={ this.state.isRecherche ?"col-auto m-0 p-0 ms-1" : "d-none"}>
                                                <select name="column" className="form form-control" value={ this.state.column} onChange={ (select) => { this.setState({ column : select.target.value})}} >
                                                    <option></option>
                                                    <option value="ref_invoice">par ref facture</option>
                                                    <option value="colis.manifestecolis.manifeste.ref_manifeste">par ref manifeste</option>
                                                    <option value="client.name">par client</option>
                                                </select>
                                            </div>
                                            <div className={ this.state.isRecherche ?"col-auto m-0 p-0 ms-1" : "d-none"}>
                                                <input type="text" name="value" onChange={(select) => { this.state.column &&( select.target.value?.length > 3 && (this.getInvoices({ column : this.state.column, value : select.target.value }))) }} />
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            
                                <div className={"tabs__content pt-30 js-tabs-content " + this.state.colTable}>
                                    <div className="tabs__pane -tab-item-1 is-tab-el-active">
                                        <div className="overflow-scroll scroll-bar-1">
                                        <table className="table_css -border-bottom col-12">
                                            <thead className="bg-light-2">
                                                <tr style={{ backgroundColor : "rgb(0, 0, 150)", color : "rgb(250, 250, 250)"}}>
                                                    <th>#</th>
                                                    <th>Réf fac</th>
                                                    <th>Réf Man</th>
                                                    <th>Client</th>
                                                    <th title="Nombre des invoices">Nbre coli</th>
                                                    <th title="Prix des invoices">Montant payé($)</th>
                                                    { this.state.typeInvoice == "Dette" && (<th>Dette restant($)</th>)}
                                                    { this.state.typeInvoice == "Cash" && (<th>Litige($)</th>)}
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { invoices }
                                            </tbody>
                                        </table>
                                        </div>

                                        <div className="">
                                            <div className="row justify-between">
                                            <div className="col-auto">
                                                <button onClick={() => this.changePage( this.state.currentPage > 2 ? this.state.currentPage - 1 : 1)} className="button -blue-1 size-40 rounded-full border-light">
                                                    <i className="fa fa-chevron-left text-12"></i>
                                                </button>
                                            </div>

                                            <div className="col-auto">
                                                <div className="row x-gap-20 y-gap-20 items-center">

                                                 { buttons.length> 0 ?  buttons : ""}

                                                </div>
                                            </div>

                                            <div className="col-auto">
                                                <button onClick={() => this.changePage( this.state.currentPage < buttons.length ? this.state.currentPage + 1 : buttons.length)} className="button -blue-1 size-40 rounded-full border-light">
                                                    <i className="fa fa-chevron-right text-12"></i>
                                                </button>
                                            </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                {
                                    this.state.loading && (<Loading /> )
                                }

                            </div>

                    <InvoiceDesign showModal={ this.showModalInvoice} formData={ this.state.formDataInvoice} isModal={ this.state.isInvoiceModal} />
                             
                        </div>

                        </div>

      
                


        )
    }
}
export default Invoice;
